import { render, staticRenderFns } from "./register.vue?vue&type=template&id=522fe7a3&scoped=true&lang=pug"
import script from "./register.vue?vue&type=script&lang=coffee"
export * from "./register.vue?vue&type=script&lang=coffee"
import style0 from "./register.vue?vue&type=style&index=0&id=522fe7a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fe7a3",
  null
  
)

export default component.exports